module.exports = __webpack_public_path__ + "img/close_fill.a69a485f.svg";